<div class="mat-typography mat-body mat-app-background" #zipInputs>
  <div class="dialog-close">
    @if (!disableClose) {
      <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal(true)">close</span>
    }
  </div>
  <article class="content-section">
    <!-- HEADER -->
    <section>
      <h1 class="header-text">
        {{displayContent.headerText}}
      </h1>
    </section>

    <!-- SUB-HEADER - seperate content sections to reduce manual configuration before/during/after AEP -->
    @if (!showYearSelector) {
      <section class="description">
        <div class='zip-sub-header'>
          {{ displayContent.basicBodyText }}
        </div>
      </section>
    }

    <!-- Individual does not use this currently, they will always have showYearSelector=false because the AEM config yearSelectionConfig.hideYearSelection will always be true -->
    @if (showYearSelector) {
      <section class="description">
        <div class='zip-sub-header'>
          {{ displayContent.yearSelectorBodyText }}
        </div>
      </section>
      <section>
        <div class="year-selection-content year-content hmhs-horizontal-padding-1-rem">
          <app-year-selection class="year-content hmhs-horizontal-padding-1-rem"
            [currentYearOverride]='data.yearSelectionConfig.currentYearOverride'
            [selectYearHeading]='data.yearSelectionConfig.selectYearHeading'
            [selectYearPrompt]='data.yearSelectionConfig.selectYearPrompt'
            [initialYearSelection]='data.yearSelectionConfig.initialYearSelection'
            [tooltipText]="data.yearSelectionConfig.tooltipText">
          </app-year-selection>
        </div>
      </section>
    }

    <!-- Functionality -->
    <div class="content-card">
      <ptl-zip-code-and-county-select (zipAndCountyChanged)="zipCountyChanged($event)" [preloadedValues]="stateValues"
        (submitFormEvent)="gotoURL(data?.viewPlansUrl)" [includeEmailField]="includeEmailField"
        (emailChanged)="emailChanged($event)">
      </ptl-zip-code-and-county-select>

      <!-- SUBMIT -->
      <section class="buttons">
        @if (!data?.hideViewPlansButton) {
          <button mat-raised-button color="primary" type="button" id="view-plans-button"
            (click)="gotoURL(data?.viewPlansUrl)" class="zip-gate-button">
            <span>{{viewPlansButtonLabel}}</span>
          </button>
        }
        @if (data?.showConnectureButton) {
          <button mat-raised-button color="primary" type="button" id="connecture-button"
            (click)="goToConnecture()" class="zip-gate-button">
            <span>{{viewPlansConnectureLabel}}</span>
          </button>
        }
      </section>
    </div>
  </article>
</div>